import type { FaceKey } from '@repo/api-contracts';

/** 면 선택·가져오기 칸이 쓰는 면 이름. 사진 카드(edit-area-photos)와 같은 표기다. */
export const FACE_LABELS: Readonly<Record<FaceKey, string>> = {
  front: '앞면 Front',
  back: '뒷면 Back',
  left: '왼쪽 Left',
  right: '오른쪽 Right',
};

/** 인쇄 영역 이름 등 문장에 끼워 쓰는 한글 면 이름(영문 병기 없음). */
export const FACE_NAMES_KO: Readonly<Record<FaceKey, string>> = {
  front: '앞면',
  back: '뒷면',
  left: '왼쪽',
  right: '오른쪽',
};
